import React from 'react';
import { Link } from 'react-router-dom'
import './TermsOfUse.css';
import logComponent from '../../common/logComponent';
export default function TermsOfUse() {

  if (logComponent('TermsOfUse')) { console.debug('TermsOfUse rendered'); }

  return (
    <Link to='../terms'
      target='_blank'>
      Terms Of Use
    </Link>
  )
}
